import React, { useRef, useState } from "react";
import DropDown from "../../../UIComponents/DropDown/DropDown";
import "./SalesSamples.css";
import SearchInput from "../../../UIComponents/SearchInput/SearchInput";
import { Button } from "antd";
import { useSelector, useDispatch } from "react-redux";
import {
  massSearchFilter,
  resetMassFilter,
  resetSeasonFilter,
  resetSrtData,
  selectUnselectSrtTableRows,
  srtBulkSave,
  srtExport,
  srtSeasonSearchFilter,
} from "../../../Redux/actions/Srt/Srt";
import Select from "../../../UIComponents/DropDown/DropDown";
import { DownloadOutlined } from "@ant-design/icons";
import { useEffect } from "react";
import { getSrtInitialList } from "../../../Redux/actions/Srt/Srt";
import { SyncOutlined } from "@ant-design/icons";
import { toast } from "../../../UIComponents/Toast";
import SalesTable from "./SalesTable";
import { useLocation, useNavigate } from "react-router-dom";
import { dashboardStyleList } from "../../../Redux/actions/Dashboard/Dashboard";
import { srfStyleList } from "../../../Redux/actions/Srf/Srf";
const TOTAL_PER_PAGE = 100;
const CHUNK_SIZE = 25;
const SalesSamples = (containerRef) => {
  const dispatch = useDispatch();
  const fileRef = useRef();
  const [searchFilter, setSearchFilter] = useState();
  const [brandFilter, setBrandFilter] = useState();
  const [teamFilter, setTeamFilter] = useState();
  const [statusFilter, setStatusFilter] = useState();
  const [vendorFilter, setVendorFilter] = useState();
  const [colorFilter, setColorFilter] = useState();
  const [sizeFilter, setSizeFilter] = useState();
  const [seasonFilter, setSeasonFilter] = useState();
  const [singleSeason, setSingleSeason] = useState([]);
  const [singleColor, setSingleColor] = useState([]);
  const [singleSize, setSingleSize] = useState([]);
  const [singleFactory, setSingleFactory] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const srtSeasonData = useSelector((state) => state?.Srt?.srtSeasonSearch);
  const srtDataList = useSelector((state) => state?.Srt?.getSrtDataList);
  const exportArraySrt = useSelector((state) => state?.Srt?.srtExportArrayData);
  const srtRefresh = useSelector((state) => state?.Srt?.srtRefreshSpinner);
  const styleListData = useSelector((state) => state?.Srf?.srfFilterData);
  const brandNameFromApi = useSelector((state) => state?.Srt?.srtBrandNames);
  const srtSaveAllData = useSelector((state) => state?.Srt?.srtSaveAllData);
  const userNameMicrosoft = useSelector(
    (state) => state?.Profile?.graphCompleteData?.displayName
  );
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const navigate = useNavigate();

  const [current, setCurrent] = useState(() => {
    const page = queryParams.get("page");
    return page ? parseInt(page) : 1;
  });

  const [pageCount, setPageCount] = useState(() => {
    const size = queryParams.get("pageSize");
    return size ? parseInt(size) : TOTAL_PER_PAGE;
  });

  useEffect(() => {
    console.log("checkingpageinsaucony", current, pageCount);
  }, [pageCount, current]);

  const updateQueryParams = (page, pageSize) => {
    const newQueryParams = new URLSearchParams(location.search);
    newQueryParams.set("page", page);
    newQueryParams.set("pageSize", pageSize);
    navigate({ search: newQueryParams.toString() }, { replace: true });
  };
  useEffect(() => {
    const page = queryParams.get("page");
    const size = queryParams.get("pageSize");

    if (page && parseInt(page) !== current) {
      setCurrent(parseInt(page));
    }

    if (size && parseInt(size) !== pageCount) {
      setPageCount(parseInt(size));
    }
  }, [location.search]);

  useEffect(() => {
    dispatch(srfStyleList("", ""));
  }, []);
  const [seasonOptions, setSeasonOptions] = useState([]);

  useEffect(() => {
    if (Array.isArray(styleListData)) {
      const uniqueSeasons = [
        ...new Set(
          styleListData
            .map((item) => item?.season?.trim().toUpperCase())
            .filter(Boolean)
        ),
      ];

      const formattedSeasons = [
        { value: "ALL", label: "Select All" },
        ...uniqueSeasons.map((season) => ({
          value: season,
          label: season,
        })),
      ];

      setSeasonOptions(formattedSeasons);
    }
  }, [styleListData, srtSeasonData]);
  useEffect(() => {
    if (Array.isArray(styleListData) && styleListData.length > 0) {
      const cleanSet = (arr) => [
        ...new Set(arr.map((item) => item?.trim()).filter(Boolean)),
      ];

      const seasons = cleanSet(styleListData.map((item) => item?.season));
      setSingleSeason(seasons);

      const vendors = styleListData
        .flatMap((item) => {
          if (Array.isArray(item.factory)) return item.factory;
          if (item.factories) return item.factories.split(",");
          return [];
        })
        .map((vendor) => vendor.trim().toLowerCase())
        .filter(Boolean);

      const uniqueSortedVendors = [...new Set(vendors)]
        .map((v) => v.charAt(0).toUpperCase() + v.slice(1))
        .sort((a, b) => a.localeCompare(b));

      setSingleFactory(uniqueSortedVendors);

      const styleColors = cleanSet(
        styleListData.flatMap((item) =>
          item?.colors ? item.colors.split(",") : []
        )
      );
      setSingleColor(styleColors);

      const styleSizes = cleanSet(
        styleListData.flatMap((item) =>
          item?.sizes ? item.sizes.split(",") : []
        )
      );
      setSingleSize(styleSizes);
    }
  }, [styleListData]);

  const brands = [
    {
      value: "Dickies Socks",
      label: "Dickies Socks",
    },
    // {
    //   value: "Dickies Underwear",
    //   label: "Dickies Underwear",
    // },
    {
      value: "EddieBauer",
      label: "EddieBauer",
    },
    // {
    //   value: "Haggar",
    //   label: "Haggar",
    // },
    {
      value: "PD",
      label: "PD & Redevelopment",
    },   
    // {
    //   value: "Saucony",
    //   label: "Saucony",
    // },
    {
      value: "My Favorite Socks",
      label: "My Favorite Socks",
    },
    {
      value: "NorthState",
      label: "NorthState",
    },
    {
      value: "True Energy",
      label: "True Energy",
    },
    {
      value: "North State Apparel",
      label: "North State Apparel",
    },
    {
      value: "RunDry",
      label: "RunDry",
    }

  ];
  const statusofsrt = [
    {
      value: "",
      label: "-",
    },
    {
      value: "Hold",
      label: "Hold",
    }, 
    {
      value: "Approved",
      label: "Approved",
    },
    {
      value: "Override",
      label: "Override",
    },
    {
      value: "N/A",
      label: "N/A",
    },
    {
      value: "Dropped",
      label: "Dropped",
    },
  ];

  const [massFilterData, setMassFilterData] = useState(() => {
    const savedData = localStorage.getItem("massFilterData");
    return savedData
      ? JSON.parse(savedData)
      : {
          searchFilter: "",
          brandFilter: "",
          colorFilter: "",
          sizeFilter: "",
          statusFilter: "",
          vendorFilter: "",
          seasonFilter: "",
          brand: "",
          sale_sample: 0,
        };
  });

  useEffect(() => {
    const srtMassFilterData = JSON.parse(localStorage.getItem("srtMassData"));
    const hasMassFilterData =
      srtMassFilterData && Object.keys(srtMassFilterData).length > 0;
    const localData = JSON.parse(localStorage.getItem("massFilterData"));

    if (hasMassFilterData) {
      dispatch(
        massSearchFilter(
          srtMassFilterData.searchFilter || "",
          srtMassFilterData.brandFilter || "",
          srtMassFilterData.colorFilter || "",
          srtMassFilterData.sizeFilter || "",
          srtMassFilterData.statusFilter || "",
          srtMassFilterData.vendorFilter || "",
          1,
          srtMassFilterData.seasonFilter || "",
          current,
          pageCount
        )
      );
    } else if (localData && localData?.seasonFilter) {
      dispatch(
        srtSeasonSearchFilter(
          localData?.brandfilter || localData?.brand || "",
          localData?.seasonFilter || "",
          current,
          pageCount,
          1,
        )
      );
    } else {
      dispatch(getSrtInitialList("", "", "", "", 1, "", current, pageCount));
    }
  }, []);

  useEffect(() => {
    localStorage.setItem("massFilterData", JSON.stringify(massFilterData));
  }, [massFilterData]);

  useEffect(() => {
    if (!srtSaveAllData?.status) return;

    const freshLocalData = JSON.parse(localStorage.getItem("srtMassData"));
    const localData = JSON.parse(localStorage.getItem("massFilterData"));
    const hasMassFilterConditions =
      freshLocalData &&
      (freshLocalData.searchFilter ||
        freshLocalData.brandfilter ||
        freshLocalData.colorFilter ||
        freshLocalData.sizeFilter ||
        freshLocalData.statusFilter ||
        freshLocalData.vendorFilter ||
        freshLocalData.seasonFilter);

    if (hasMassFilterConditions) {
      dispatch(
        massSearchFilter(
          freshLocalData?.searchFilter || "",
          freshLocalData?.brandfilter || "",
          freshLocalData?.colorFilter || "",
          freshLocalData?.sizeFilter || "",
          freshLocalData?.statusFilter || "",
          freshLocalData?.vendorFilter || "",
          1,
          freshLocalData?.seasonFilter || "",
          current,
          pageCount
        )
      );
      return;
    }

    if (localData?.seasonFilter) {
      dispatch(
        srtSeasonSearchFilter(
          localData?.brandfilter || localData?.brand || "",
          localData?.seasonFilter || "",
          current,
          pageCount,
          1
        )
      );
      return;
    }

    dispatch(getSrtInitialList("", "", "", "", 1, "", current, pageCount));
  }, [dispatch, srtSaveAllData, current, pageCount]);

  const onSearchChange = (e) => {
    setSearchFilter(e.target.value);
    // setMassFilterData((prevData) => ({
    //   ...prevData,
    //   searchFilter: e.target.value,
    // }));
  };

  const onBrandChange = (value) => {
    setBrandFilter(value);
    setMassFilterData((prevData) => ({ ...prevData, brandFilter: value }));
  };

  const onStatusChange = (value) => {
    const finalValue = Array.isArray(value) ? value[0] : value;
    setStatusFilter(finalValue);
    setMassFilterData((prev) => ({ ...prev, statusFilter: finalValue }));
  };

  const onSeasonChange = (values) => {
    if (!values  || values.length === 0 ) {
      handleSeasonClear();
      return;
    }
    setCurrent(1);
    setPageCount(TOTAL_PER_PAGE);
    updateQueryParams(1, TOTAL_PER_PAGE);
    dispatch(srtSeasonSearchFilter("", values, 1, TOTAL_PER_PAGE, 1));
    setSeasonFilter(values);
    localStorage.removeItem("srtData");
    localStorage.removeItem("massFilterData");
    dispatch(resetMassFilter([]));
    dispatch(resetSrtData([]));
    setMassFilterData((prevData) => ({ ...prevData, seasonFilter: values }));
  };

  const onFactoryChange = (value) => {
    setVendorFilter(value);
    setMassFilterData((prevData) => ({ ...prevData, vendorFilter: value }));
  };

  const onColorChange = (value) => {
    setColorFilter(value);
    setMassFilterData((prevData) => ({ ...prevData, colorFilter: value }));
  };

  const onSizeChange = (value) => {
    setSizeFilter(value);
    setMassFilterData((prevData) => ({ ...prevData, sizeFilter: value }));
  };
  const onSubmitClick = () => {
    setCurrent(1);
    setPageCount(TOTAL_PER_PAGE);
    updateQueryParams(1, TOTAL_PER_PAGE);
    localStorage.setItem(
      "srtMassData",
      JSON.stringify({
        searchFilter: searchFilter,
        brandfilter: brandFilter,
        colorFilter: colorFilter,
        sizeFilter: sizeFilter,
        statusFilter: statusFilter,
        vendorFilter: vendorFilter,
        sale_samplefilter: 1,
        seasonFilter: seasonFilter,
      })
    );
    dispatch(
      massSearchFilter(
        searchFilter ? searchFilter : "",
        brandFilter ? brandFilter : "",
        colorFilter ? colorFilter : "",
        sizeFilter ? sizeFilter : "",
        statusFilter ? statusFilter : "",
        vendorFilter ? vendorFilter : "",
        1,
        seasonFilter ? seasonFilter : "",
        1,
        TOTAL_PER_PAGE
      )
    );
  };
  const exportToExcelDickies = () => {
    if (searchFilter && vendorFilter && exportArraySrt.length > 0) {
      toast.error("!Please select either style and Vendor Filter or style ids");
    } else if (
      vendorFilter === null ||
      (vendorFilter === undefined &&
        searchFilter &&
        exportArraySrt.length === 0)
    ) {
      toast.error("!Please select either style and Vendor Filter or style ids");
    } else if (
      searchFilter === null ||
      (searchFilter === undefined &&
        vendorFilter &&
        exportArraySrt.length === 0)
    ) {
      toast.error("!Please select either style and Vendor Filter or style ids");
    } else {
      dispatch(
        srtExport({
          style:
            searchFilter === null || searchFilter === undefined
              ? ""
              : searchFilter,
          factory:
            vendorFilter === null || vendorFilter === undefined
              ? ""
              : vendorFilter,
          style_pids: exportArraySrt,
          sale_sample: "1",
        })
      );
      dispatch(selectUnselectSrtTableRows([]));
      dispatch(srtEXportArray([]));
    }
  };
  const onRefresh = () => {
    localStorage.removeItem("srtMassData");
    localStorage.removeItem("massFilterData");
    localStorage.removeItem("currentPage");
    localStorage.setItem(
      "srtData",
      JSON.stringify({
        brand: "",
        style: "",
        factory: "",
        rejected_date: "",
        sale_sample: 1,
      })
    );
    dispatch(getSrtInitialList("", "", "", "", 1, "", 1, TOTAL_PER_PAGE));
    dispatch(resetSeasonFilter([]));
    dispatch(resetMassFilter([]));
    dispatch(selectUnselectSrtTableRows([]));
    setSearchFilter();
    setBrandFilter();
    setColorFilter();
    setSizeFilter();
    setStatusFilter();
    setVendorFilter();
    setCurrent(1);
    setPageCount(TOTAL_PER_PAGE);
    updateQueryParams(1, TOTAL_PER_PAGE);
    handleSeasonClear();
  };
  const onSearchEnter = (event) => {
    if (event.key === "Enter") {
      if (searchFilter === null) {
        toast.error("Please Enter Details");
      } else {
        setCurrent(1);
        setPageCount(TOTAL_PER_PAGE);
        updateQueryParams(1, TOTAL_PER_PAGE);
        localStorage.setItem(
          "srtMassData",
          JSON.stringify({
            searchFilter: searchFilter,
            brandfilter: "",
            colorFilter: "",
            sizefilter: "",
            statusFilter: "",
            vendorFilter: "",
            sale_samplefilter: 1,
            seasonFilter: seasonFilter ? seasonFilter : "",
          })
        );
        dispatch(
          massSearchFilter(
            searchFilter ? searchFilter : "",
            "",
            "",
            "",
            "",
            "",
            1,
            seasonFilter ? seasonFilter : "",
            1,
            TOTAL_PER_PAGE
          )
        );
        setSearchFilter();
      }
    }
  };
  const onSrtBulkUpload = (e) => {
    let formData = new FormData();
    formData.append("files", e.target.files[0]);
    formData.append("sale_sample", "1");
    formData.append("user", userNameMicrosoft);
    dispatch(srtBulkSave(formData, brandNameFromApi));
    e.target.value = null;
    formData = new FormData();
  };
  const handleSeasonClear = () => {
    const savedData = localStorage.getItem("massFilterData");
    if (savedData) {
      try {
        const parsedData = JSON.parse(savedData);
        const { seasonFilter, ...updatedData } = parsedData;

        localStorage.setItem("massFilterData", JSON.stringify(updatedData));

        setMassFilterData((prev) => ({
          ...prev,
          seasonFilter: "",
        }));

        setSeasonFilter();

        dispatch(getSrtInitialList("", "", "", "", 1, "", 1, TOTAL_PER_PAGE));
        updateQueryParams(1, TOTAL_PER_PAGE);
        setCurrent(1);
        setPageCount(TOTAL_PER_PAGE);
      } catch (error) {
        console.error("Error parsing localStorage data:", error);
      }
    } else {
      setMassFilterData((prev) => ({
        ...prev,
        seasonFilter: "",
      }));
      setSeasonFilter();
      dispatch(getSrtInitialList("", "", "", "", 1, "", 1, TOTAL_PER_PAGE));
    }
  };
  return (
    <div className="dickies-main-container">
      <div className="dickies-first-two-dropdowns">
        <div className="dickies-drop-down-one">
          <DropDown
            mode="multiple"
            allowClear
            onChange={onSeasonChange}
            onClear={handleSeasonClear}
            placeholder={"Season"}
            option={seasonOptions}
            value={seasonFilter}
            enableSelectAll
          />
        </div>
        <h2>SALES SAMPLES</h2>
        <div className="dickies-drop-down-two">
          <Button icon={<DownloadOutlined />} onClick={exportToExcelDickies}>
            Export
          </Button>
        </div>
      </div>

      {/* search dropdown button */}
      <div className="search-dropdown-button">
        <div className="dickies-search-input">
          <SearchInput
            // maxLength={10}
            onKeyPress={onSearchEnter}
            onChange={onSearchChange}
            value={searchFilter}
            placeholder={"Search by Parent Style"}
            onInput={(e) => {
              e.target.value = e.target.value.replace(/[^a-zA-Z0-9," ]/g, "");
            }}
          />
        </div>
        <div className="dropdown-width dickies-drop-down-five">
          <Select
            allowClear
            placeholder={"Vendor"}
            data={singleFactory}
            value={vendorFilter}
            onChange={onFactoryChange}
          ></Select>
        </div>
        <div className="dropdown-width dickies-drop-down-five">
          <Select
            allowClear
            placeholder={"Color"}
            data={singleColor}
            value={colorFilter}
            onChange={onColorChange}
          ></Select>
        </div>
        <div className="dropdown-width dickies-drop-down-five">
          <Select
            allowClear
            placeholder={"Size"}
            data={singleSize}
            value={sizeFilter}
            onChange={onSizeChange}
          ></Select>
        </div>
        <div className="dropdown-width dickies-drop-down-five">
          <DropDown
            allowClear
            onChange={onBrandChange}
            placeholder={"Brand"}
            value={brandFilter}
            option={brands}
          />
        </div>
        {/* <div className="dropdown-width dickies-drop-down-five">
          <DropDown
            allowClear
            onChange={onTeamChange}
            placeholder={"Team"}
            option={team}
            value={teamFilter}
          />
        </div> */}
        <div className="dropdown-width dickies-drop-down-five">
          <DropDown
            allowClear
            onChange={onStatusChange}
            placeholder={"Status"}
            option={statusofsrt}
            value={statusFilter}
          />
        </div>
        <div className="sync-icon">
          <SyncOutlined spin={srtRefresh} onClick={onRefresh} />
        </div>
        <div>
          <Button
            onClick={onSubmitClick}
            className="dickies-button"
            children={"SUBMIT"}
          />
        </div>
        <div>
          <Button
            className="dickies-button"
            onClick={() => fileRef.current.click()}
          >
            Bulk Update
          </Button>
          <input
            type="file"
            onChange={onSrtBulkUpload}
            accept="image/jpeg/png/jpg , application/pdf,.csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
            ref={fileRef}
            hidden
          />
        </div>
      </div>
      <div className="srt-table-container">
        <SalesTable
          selectedRows={selectedRows}
          onSelectionChange={setSelectedRows}
          current={current}
          pageCount={pageCount}
          setCurrent={setCurrent}
          setPageCount={setPageCount}
          data={massFilterData}
          totalPerPage={TOTAL_PER_PAGE}
          chunkSize={CHUNK_SIZE}
          containerRef={containerRef}
        />
      </div>
    </div>
  );
};

export default SalesSamples;
